import { render } from "./AccessAddGroup.vue?vue&type=template&id=e5012198"
import script from "./AccessAddGroup.vue?vue&type=script&lang=js"
export * from "./AccessAddGroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__